import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';

const FusionSectionTitle: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className }) => {
  return (
    <>
      <h2 className={classNames(styles.fusionSectionTitle, className)}>{children}</h2>
    </>
  );
};

export default FusionSectionTitle;
